<template>
	<div class="position-relative">
        <hourglass-loader :show="loading" />
		<div class="row">
			<div class="col-md-10">
				<logging-filter-bar placeholder="Search Log"></logging-filter-bar>
			</div>
			<div class="col-md-2 d-flex align-items-center justify-content-end">
				<base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
			</div>
		</div>
		<div class="dataTables_wrapper container-fluid dt-bootstrap4 modern">
			<vuetable ref="vuetable"
                :api-url="grid"
                :fields="fields"
                :css="css.table"
                :per-page="perPage"
                :append-params="moreParams"
                :load-on-start="false"
                noDataTemplate="No Communication Logs Found"
                pagination-path=""
                @vuetable:pagination-data="onPaginationData"
                @vuetable:loading="loading = true"
                @vuetable:loaded="loading = false"
                @vuetable:load-error="onLoadError"
                @vuetable:load-success="onLoadSuccess"
			>
				<template slot="result" slot-scope="props">
					<button class="btn btn-outline-success" v-on:click="displayMessage(props.rowData.message, '', 'log-success')" v-if="props.rowData.result == 'SUCCESS'">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        <span>Success</span>
                    </button>
					<button class="btn btn-outline-danger" v-on:click="displayMessage(props.rowData.message, '', 'log-error')"  style="color:#ef5350; " v-if="props.rowData.result == 'FAIL'">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        <span>Error</span>
                    </button>
                    <button class="btn btn-outline-warning" v-on:click="displayMessage(props.rowData.message, '', 'log-warning')"  style="color:#e07a00; " v-if="props.rowData.result == 'WARNING'">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        <span>Warning</span>
                    </button>
					<button class="btn btn-outline-secondary" v-on:click="displayMessage(props.rowData.message, '', 'log-ignore')"  style="color:#76767b; " v-if="props.rowData.result == 'IGNORE'">
                        <i class="fa fa-info-circle" aria-hidden="true"></i>
                        <span>Ignore</span>
                    </button>
				</template>
				<template slot="product" slot-scope="props">
					<a class="btn btn-outline-primary" :href="'/products/' + props.rowData.pcs_id + '/edit/'" v-if="props.rowData.pcs_id && props.rowData.action.includes('PRODUCT')">View Product</a>
				</template>
                <template slot="debug" slot-scope="props">
					<div class="btn btn-outline-primary" v-on:click="displayMessage('Request: '+props.rowData.request_payload+' Response: '+props.rowData.response+' Headers: ' + props.rowData.headers , '')"><i class="fa" aria-hidden="true"></i> View Details</div>
				</template>
			</vuetable>
			<div class="row">
				<div class="col-md-6">
					<base-pagination-info
							:css="css.table"
							ref="paginationInfo"
					>
					</base-pagination-info>
				</div>
				<div class="col-md-6">
					<base-pagination  ref="pagination" @vuetable-pagination:change-page="onChangePage" :showFirstAndLastLinks="true"></base-pagination>
				</div>
			</div>
		</div>
		<div class="modal fade" id="modalLogMessage">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Message</h4>
					</div>
					<div class="modal-body modal-longtext" :class="current_message.style">
						<div v-if="current_message.errors.length">
                            <div v-for="(error, index) in current_message.errors" :class="{ 'mt-2': index > 0 }">
                                {{ error }}
                            </div>
                        </div>
                        <div v-else>{{ current_message.message }}</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped lang="scss">
.log-success {
    color: #4caf50;
    word-wrap: break-word;
}
.log-error {
    color: #ef5350;
    word-wrap: break-word;
}
.log-warning {
    color: #e07a00;
    word-wrap: break-word;
}
.log-ignore {
    color: #76767b;
    word-wrap: break-word;
}
</style>

<script type="text/javascript">
import moment from "moment-timezone";

var base_url = window.location.protocol + "//" + window.location.host;

import Vue from "vue";
import VueEvents from "vue-events";
import BaseFilterBar from "./logging-filter-bar.vue";
import BasePagination from "./base-pagination.vue";
import BasePaginationInfo from "./base-pagination-info.vue";
import BaseSelectVisible from "./base-select-visible.vue";
import hourglassLoader from "../generic/hourglass-loader.vue"
import axios from "axios";

Vue.use(VueEvents);

export default {
    name: "communication-logs-listing",
    props: ["visibleDays", "customPerPage"],
    components: {
        "logging-filter-bar": BaseFilterBar,
        "base-pagination": BasePagination,
        "base-pagination-info": BasePaginationInfo,
        "base-select-visible": BaseSelectVisible,
        hourglassLoader,
    },
    data() {
        return {
            perPage: this.customPerPage,
            moreParams: {},
            loading: true,
            current_message: {
                errors: [],
                message: null,
                style: null
            },
            visible_days: this.visibleDays,
            fields: [
                {
                    name: "__slot:result",
                    title: "Result"
                },
                {
                    name: "http_code",
                    title: "HTTP Code"
                },
                {
                    name: "action",
                    title: "Action"
                },
                {
                    name: "bc_store",
                    title: "Store"
                },
                {
                    name: "bc_id",
                    title: "Web ID",
                    dataClass: "text-center"
                },
                {
                    name: "pcs_id",
                    title: "PIM ID",
                    dataClass: "text-center"
                },
                {
                    name: "__slot:product",
                    title: "Product",
                    dataClass: "text-center"
                },
                {
                    name: "processed_time",
                    title: "Time",
                    callback: 'formatDate',
                },
                {
                    name: "__slot:debug",
                    title: "Debug"
                }
            ],
            amountsShown: [
                { text: "10", value: 10 },
                { text: "25", value: 25 },
                { text: "50", value: 50 },
                { text: "100", value: 100 }
            ],
            grid: base_url + "/communication-logs/grid/" + this.visibleDays,
            css: {
                table: {
                    tableClass:
                        "table table-striped table-bordered table-middle",
                    ascendingIcon: "sort-icon-asc",
                    descendingIcon: "sort-icon-desc",
                    infoClass: ""
                }
            },
            clientTimezone: null
        };
    },
    mounted() {
        this.$events.$on("per-page", eventData => this.doVisibleSet(eventData));
        this.$events.$on("filter-set", eventData =>
            this.onFilterSet(eventData)
        );
        this.$events.$on("filter-reset", e => this.onFilterReset());
        this.getClientTimezone();
    },
    watch: {
        perPage(val, oldVal) {
            this.$nextTick(function() {
                this.$refs.vuetable.refresh();
            });
        }
    },
    methods: {
        displayMessage(message, errors, status) {
            if (message != "") {
                this.current_message.message = message;
            } else {
                if (!errors.length) {
                    this.current_message.message = "Action performed successfully";
                }
                else {
                    this.current_message.message = "A problem was encountered";
                }
            }

            if (errors.length) {
                this.current_message.errors = errors;
            } else {
                this.current_message.errors = [];
            }

            this.current_message.style = status;

            $("#modalLogMessage").modal("show");
        },
        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },
        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },
        doVisibleSet(perPageValue) {
            this.perPage = perPageValue;
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onFilterSet(filterObj) {
            this.moreParams = {
                action: filterObj.action,
                bc_id: filterObj.bcId,
                channel_id: filterObj.channelId,
                start_time: filterObj.startProcessedTime,
                end_time: filterObj.endProcessedTime,
                pcs_id: filterObj.pcsId,
                message: filterObj.message,
                result: filterObj.statusType,
                entity_type: filterObj.entityType,
                http_code: filterObj.httpCode
            };

            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },
        onLoadSuccess: function() {
            this.current_message = {
                errors: [],
                message: null,
                style: null
            }

            this.loading = false;
        },
        onLoadError: function(error) {
            let message = error.response.data.message;
            let errors = error.response.data.errors;

            if (errors) {
                errors =  Object.keys(errors).map(key => {
                    return errors[key].reduce((arr, current) => {
                        arr.push(current);

                        return arr;
                    }, []);
                }).flat();
            }

            this.displayMessage(message, errors, "error");
        },
        getClientTimezone: function() {
            axios
                .get(
                    base_url +
                    "/client-timezone/",
                    {
                        // 'criteria': criteria,
                    }
                )
                .then(
                    function(response) {
                        this.clientTimezone = response.data.clientTimezone
                    }.bind(this)
                )
                .catch(
                );
        },
        formatDate(value) {
            if (value === null) {
                return '';
            }

            if (this.clientTimezone) {
                return moment.utc(value).tz(this.clientTimezone).format('MMM Do YYYY h:mm a');
            } else{
                return moment(value).format("MMM Do YYYY, h:mm a");
            }
        }
    }
};
</script>
